(() => {
  const STICKY_DRAWER_SELECTOR = '.product-buy-buttons--drawer';
  const WA_CONTAINER_SELECTOR = '.wa-preview-corner-button-container';
  const observedDrawers = new WeakSet();
  const baseBottoms = new WeakMap();

  const getStickyOffset = () => {
    const drawer = document.querySelector(
      `${STICKY_DRAWER_SELECTOR}[aria-hidden="false"]`
    );
    return drawer ? drawer.getBoundingClientRect().height : 0;
  };

  const updateWhatsAppPosition = () => {
    const offset = getStickyOffset();

    document.querySelectorAll(WA_CONTAINER_SELECTOR).forEach((el) => {
      if (!baseBottoms.has(el)) {
        const computedBottom = parseFloat(getComputedStyle(el).bottom);
        baseBottoms.set(el, Number.isFinite(computedBottom) ? computedBottom : 16);
      }

      const baseBottom = baseBottoms.get(el);
      el.style.bottom = offset ? `${baseBottom + offset}px` : `${baseBottom}px`;
    });
  };

  const observeDrawer = (drawer) => {
    if (observedDrawers.has(drawer)) return;
    observedDrawers.add(drawer);

    new ResizeObserver(updateWhatsAppPosition).observe(drawer);
    new MutationObserver(updateWhatsAppPosition).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  };

  const init = () => {
    document.querySelectorAll(STICKY_DRAWER_SELECTOR).forEach(observeDrawer);
    updateWhatsAppPosition();
  };

  let initTimer;
  const scheduleInit = () => {
    clearTimeout(initTimer);
    initTimer = setTimeout(init, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(scheduleInit).observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('resize', updateWhatsAppPosition, { passive: true });
})();
